import logoUrl from '../../assets/Menusso_logo.svg';
import './LoginPage.scss';
import { useTranslation } from 'react-i18next';
import Input from '../../components/input/Input';
import { Button } from '@mui/material';
import { useNotify } from 'react-admin';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import axiosInstance from '../../core/axiosConfig';
import * as Sentry from '@sentry/react';
import LanguageSwitcher from '../../components/language-switcher/LanguageSwitcher';

export default function ForgotPasswordPage() {
    const notify = useNotify();
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const { t } = useTranslation();

    const validationSchema = Yup.object({
        email: Yup.string().email(t('forgotPassword.invalidEmail')).required(t('forgotPassword.emailRequired')),
    });

    return (
        <Formik
            initialValues={{ email: '' }}
            validationSchema={validationSchema}
            validateOnBlur
            validateOnChange
            onSubmit={async (values, { setSubmitting }) => {
                setLoading(true);
                try {
                    await axiosInstance.post('/auth/reset-password', { email: values.email });
                    setSent(true);
                } catch (e: any) {
                    console.error(e.response?.data ?? e);
                    notify(t('forgotPassword.failed'), { type: 'error' });
                    Sentry.captureException(e);
                } finally {
                    setLoading(false);
                    setSubmitting(false);
                }
            }}
        >
            {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
                <Form className="login login--centered">
                    <div className="login__language">
                        <LanguageSwitcher />
                    </div>
                    <div className="login__card login__card--elevated">
                        <img className="login__logo" src={logoUrl} alt="Menusso logo" />
                        <div>
                            <p className="login__title">{t('forgotPassword.title')}</p>
                            {!sent && <p className="login__subtitle">{t('forgotPassword.subtitle')}</p>}
                        </div>
                        {sent ? (
                            <div className="login__form">
                                <p className="login__subtitle">{t('forgotPassword.successMessage')}</p>
                                <Link to="/login" className="login__forgot-password">{t('forgotPassword.backToLogin')}</Link>
                            </div>
                        ) : (
                            <div className="login__form">
                                <Input
                                    name="email"
                                    label={t('login.email')}
                                    type="email"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    autoComplete="email"
                                    error={Boolean(touched.email && errors.email)}
                                    helperText={touched.email ? errors.email : undefined}
                                    aria-invalid={Boolean(touched.email && errors.email)}
                                    aria-describedby="email-error"
                                />
                                <Button
                                    className="login__submit"
                                    variant="contained"
                                    fullWidth
                                    type="submit"
                                    disabled={isSubmitting || loading}
                                >
                                    {t('forgotPassword.submit')}
                                </Button>
                                <Link to="/login" className="login__forgot-password">{t('forgotPassword.backToLogin')}</Link>
                            </div>
                        )}
                    </div>
                </Form>
            )}
        </Formik>
    );
}
